<template>
  <div class="tag-selector-tree">
    <div
      v-for="tagType in tagTypes"
      :key="tagType"
      class="tag-selector-tree-type"
    >
      <span
        :class="{ active: expandCollapseTypesTree[tagType] }"
        class="tag-type-name"
        @click="toggleExpandType(tagType)"
      >
        {{ tagType }}
      </span>

      <ul
        v-show="forSearch || expandCollapseTypesTree[tagType]"
        class="tag-selector-tree-name list-unstyled"
      >
        <li
          v-for="(tag, index) in sortedTagsByType[tagType].tags"
          :key="index"
          class="tag-name"
        >
          <a @click.prevent="$emit('selectTag', tag)">
            <span v-if="tag.displayName">
              {{ tag.displayName }}
            </span>

            <span v-else>
              {{ tag.tagName | camelCaseFormat }}
            </span>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { sortBy, mapValues, groupBy } from 'lodash';
import { camelCaseFormat } from '@/core/filters/camelCaseFormat';

export default {
  props: {
    tags: {
      type: Array,
      default() {
        return [];
      }
    },
    tagSource: {
      type: String,
      default() {
        return '';
      }
    },
    forSearch: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data: function() {
    return {
      expandCollapseTypesTree: {}
    };
  },
  computed: {
    sortedTagsByType: function() {
      const filteredTags = this.tagSource ? this.tags.filter(t => t.tagSource == this.tagSource) : this.tags;
      
      return mapValues(
        groupBy(filteredTags, function (tag) {
          return tag.camelCaseFormatTagType || tag.camelCaseFormatTagType === undefined ? camelCaseFormat(tag.tagType) : tag.tagType;
        }),
        tags => {
          return {
            tagSource: tags[0]?.tagSource,
            tags: sortBy(tags, 'tagName')
          };
        });
    },
    tagTypes: function () {
      return sortBy(Object.entries(this.sortedTagsByType), ([tagType, groupedTypeTags]) => { 
        return groupedTypeTags.tagSource;
      }).map(([tagType]) => tagType);
    },
    searchTagType: function () {
      return this.tagTypes[0] || '';
    }
  },
  methods: {
    toggleExpandType: function(tagType) {
      // Emit event to load tag properties for the tag type
      // this should mutate the existing list of tags
      // We're doing this mainly for reporting tags, where in we lazy load the tag properties from the API
      // Ideally, we will load the tag properties in the background

      // TODO: Eager Load the tag properties and keep it in the store
      this.$emit('loadTagTypeData', tagType);
      this.$set(this.expandCollapseTypesTree, tagType, !this.expandCollapseTypesTree[tagType]);
    }
  }
};
</script>

<style lang="scss" scoped>
.tag-selector-tree {
  color: var(--component-tag-selector-font-color);
  padding: 12px 5px;

  .tag-selector-tree-type {
    &:not(:last-of-type) {
      margin-bottom: 15px;
    }

    > .tag-type-name {
      cursor: pointer;
      font-size: 1.2em;

      &:before {
        content: '\f105';
        font-family: "FontAwesome";
        width: 40px;
        display: inline-block;
        text-align: center;
      }

      &.active {
        font-weight: 500;
        &:before {
          content: '\f107';
          color: var(--component-tag-selector__tag-type--active-font-color);
        }
      }
    }

    .tag-selector-tree-name {
      margin: 5px 0 0 40px;

      .tag-name {

        &:not(:last-of-type) {
          margin-bottom: 15px;
        }

        > a {
          cursor: pointer;
          display: inline-block;
          font-size: 1.1em;

          &:before {
            content: '\f02b';
            font-family: "FontAwesome";
            margin-right: 5px;
            font-size: 0.9em;
          }

          &:hover {
            color: var(--component-tag-selector__tag-name--hover-font-color);
          }
        }
      }

    }
  }
}
</style>